import React from "react"
import ReactDOM from "react-dom/client"
import "@/App.css"
import AuthProvider from "@/routes/authProvider.tsx"
import Router from "@/routes/router.tsx"
import { ThemeProvider } from "@mui/material"
import MainTheme from "./themes/main"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { EventProvider } from "./contexts/EventContext"
import { AttractionProvider } from "./contexts/AttractionContext"
import "@fontsource-variable/baloo-bhai-2"
import { SnackbarProvider } from "./contexts/SnackbarContext"
import ReactGA from "react-ga4"
import { HelmetProvider } from "react-helmet-async"
import * as Sentry from "@sentry/react"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
dayjs.extend(timezone)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

const initGA = () => {
  ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS_KEY, {
    gaOptions: {
      debug_mode: import.meta.env.DEV,
    },
    gtagOptions: {
      debug_mode: import.meta.env.DEV,
    },
  }) // Replace with your GA4 Measurement ID
}

Sentry.init({
  dsn: "https://2c65a00ced6d9fa469d6c05ac6346d37@o4509047300489216.ingest.us.sentry.io/4509067978801152",
  environment: process.env.NODE_ENV || "development",
})

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SnackbarProvider>
      <ThemeProvider theme={MainTheme}>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <AttractionProvider>
                <EventProvider>
                  <HelmetProvider>
                    <Router />
                  </HelmetProvider>
                </EventProvider>
              </AttractionProvider>
            </LocalizationProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </SnackbarProvider>
  </React.StrictMode>
)

initGA()
